module.exports = __webpack_public_path__ + "img/tab-gift.1bdf1f20.png";